import React, { useState } from 'react';

import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';

import { APIHelpRequest, APIHelpRequestType } from '@cd3p/core/types/api';
import { Button } from 'components';
import { useHandleApiResult } from 'hooks/useHandleApiResult';

import { SupportModal } from './SupportModal';

import { styled, useTheme, useTranslation } from 'third-party';

import { useHelpCenter } from 'modules/helpCenter';

const SupportButton = styled(Button)`
  font-weight: 900;
  gap: 0.8rem;
  white-space: nowrap;
`;

type ContactSupportButtonProps = {
  preselectedSubject?: APIHelpRequestType;
};

export const ContactSupportButton: React.FC<ContactSupportButtonProps> = ({
  preselectedSubject,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const handleApiResult = useHandleApiResult();
  const { sendSupportRequest } = useHelpCenter();

  const [showSupportModal, setShowSupportModal] = useState(false);

  const onSupportModalSubmit = (support: APIHelpRequest) => {
    handleApiResult(
      () => sendSupportRequest(support),
      ({ showBaseToast }) => {
        showBaseToast(t('support.send'));
      },
    );
  };

  const handleSupportClick = () => {
    setShowSupportModal(true);
  };

  return (
    <>
      <SupportButton
        variant="outlined"
        color="secondary"
        onClick={handleSupportClick}
      >
        <ContactSupportOutlinedIcon
          style={{ width: '2rem', height: '2rem' }}
          sx={{ color: theme.custom.palette.secondary500 }}
        />
        {t('support.title')}
      </SupportButton>
      {showSupportModal && (
        <SupportModal
          onClose={() => setShowSupportModal(false)}
          onSuccess={onSupportModalSubmit}
          preselectedSubject={preselectedSubject}
        />
      )}
    </>
  );
};
